import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { renderRoutes } from 'react-router-config';
import { withRouter } from 'react-router-dom';
import compose from 'lodash.flowright';

import useMembershipsGTMDimensions from './hooks/useMembershipsGTMDimensions';

const propTypes = {
  route: PropTypes.object.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

const MembershipsMasterView = ({ route, location }) => {
  useMembershipsGTMDimensions(location);

  return <Fragment>{renderRoutes(route.routes)}</Fragment>;
};

MembershipsMasterView.propTypes = propTypes;

export default compose(withRouter)(MembershipsMasterView);
